import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import FlexColumn from '../../FlexColumn'
import { useFormattingContext } from '../../../organisms/FormattingProvider/FormattingContext'
import FlexRow from '../../FlexRow'
import Icon from '../../../atoms/Icon'
import MarkupPreview from '../../../atoms/MarkupPreview'

export default function NoteV2 ({
  activity, length, onClick, className, style, icons = {
    pinned: 'pin',
    unpinned: 'unpin'
  }
}) {
  const { formatter } = useFormattingContext()
  const _style = {
    backgroundColor: '#fbfcbd',
    border: '1px solid #ffe09c',
    ...(style || {})
  }

  return (
    <FlexColumn className={clsx(className, 'gap-sm clickable radius-md p-md shadow-sm')} style={_style} onClick={onClick}>
      <FlexRow className='gap-md justify-start' style={{ alignItems: 'flex-start' }}>
        {activity.pinned ? <Icon name={icons.pinned} customSize={20} color='var(--color-primary-400)' /> : <Icon name={icons.unpinned} customSize={20} color='var(--color-neutral-500)' />}
        <FlexColumn className='flex-1'>
          <p className='m-0 font-bold font-size-xs'>{activity.subject}</p>
          <MarkupPreview type='html' length={length} value={activity.content} className='font-size-sm' />
        </FlexColumn>
        <FlexColumn>
          <div style={{ textTransform: 'uppercase' }}>{formatter(activity.createdDate, 'date')}</div>
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  )
}

NoteV2.propTypes = {
  activity: PropTypes.shape({
    subject: PropTypes.string,
    content: PropTypes.string,
    createdDate: PropTypes.string,
    pinned: PropTypes.bool
  }).isRequired,
  className: PropTypes.string,
  length: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  icons: PropTypes.shape({
    pinned: PropTypes.string,
    unpinned: PropTypes.string
  })
}
